import React, { useEffect } from "react";
import Notification from "./components/NotificationComponent";
import { useDispatch, useSelector } from 'react-redux';

export default function NotificationSelector({ children }) {
  const notificationStatus = useSelector((state) => state.notificationAlert);
  const dispatch = useDispatch();

  useEffect(() => {
  }, [])

  return (
    <>
      <Notification
        open={notificationStatus.open}
        type={notificationStatus.type}
        message={notificationStatus.message}
        setOpen={() => dispatch({type: "SHOW_NOTIFICATION", data: {open: false},})}
      />
      {children}
    </>
  );
}
